module.exports = __webpack_public_path__ + "static/media/LT.bc425441.svg";